module.exports = __webpack_public_path__ + "static/media/ehealth-red-popup-mobile.96344058.png";